'use strict';


module.exports = function (client) {

    client.disco.addFeature('urn:xmpp:idle:1');
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/idle.js
// module id = 584
// module chunks = 2